import script from "./FilePermitionsUserGroupList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilePermitionsUserGroupList.vue?vue&type=script&setup=true&lang=ts"

import "./FilePermitionsUserGroupList.vue?vue&type=style&index=0&id=06e457c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06e457c4"]])

export default __exports__